import { ConfigProvider } from "antd";
import React from "react";

const WorkforceDetailsFieldComponent = ({ children, fieldName, fieldId, className}) => {
  return (
    <div className={`flex flex-col gap-2 ${className ?? ""}`}>
      <div className="text-xs font-semibold">
        <label htmlFor={fieldId}>
          <p>{fieldName}</p>
        </label>
      </div>
      <div>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: "blue",
              borderRadius: 5,
            },
          }}
        >
          {children}
        </ConfigProvider>
      </div>
    </div>
  );
};

export default WorkforceDetailsFieldComponent;
